module.exports = __webpack_public_path__ + "img/Group 92.e49bfa5e.png";